import {Box, Spinner} from '@primer/react'

export const LoadingFallback = () => {
  return (
    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', py: 3}}>
      <Spinner aria-label="Loading" />
    </Box>
  )
}

try{ LoadingFallback.displayName ||= 'LoadingFallback' } catch {}